import React from "react";
import "./TruckstopHelpModal.css";

const TruckstopHelpModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="truckstop-help-modal-overlay" onClick={onClose}>
      <div
        className="truckstop-help-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <h2>🪧 Get Your Truckstop Integration ID</h2>
        <div className="modal-content">
          <p className="intro">
            To use this feature, you'll first need a Truckstop Pro account.
            Here's how:
          </p>

          <div className="step">
            <h3>
              <span className="step-number">1️⃣</span> Sign up for Truckstop Pro
              Account
            </h3>
            <p>
              Visit{" "}
              <a
                href="https://truckstop.com/?pscd=partners.truckstop.com&ps_partner_key=YTlhNDUwZjE4YzAy&ps_xid=qBzezxb0bnZ3yZ&gsxid=qBzezxb0bnZ3yZ&gspk=YTlhNDUwZjE4YzAy"
                target="_blank"
                rel="noopener noreferrer"
              >
                truckstop
              </a>{" "}
              and create a Pro account with our exclusive discount — valid until
              October.
            </p>
            <p className="note">
              Truckstop may require your business and payment details.
            </p>
          </div>

          <div className="step">
            <h3>
              <span className="step-number">2️⃣</span> Request Your Integration
              ID
            </h3>
            <p>
              If you have your Pro account, click the button below to send an
              email request:
            </p>
            <div style={{ margin: "20px 0" }}>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=TSI@truckstop.com&cc=sales@cinesis.ai,NateIvie@truckstop.com&su=Truckstop API Access Request to Integrate with Cinesis&body=Dear Truckstop team,%0A%0AI would like to request my integration ID for Cinesis for my Truckstop account.%0A%0AMy Truckstop account ID: [INSERT YOUR ID]%0A%0AThanks!"
                className="copy-template-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                📧 Send Email Request
              </a>
            </div>
          </div>

          <div className="step">
            <h3>
              <span className="step-number">3️⃣</span> Enter your Integration ID
              here
            </h3>
            <p>You'll receive it within 1–2 business days.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TruckstopHelpModal;
